import SettingsLayout from "../Layout";

import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';

// Tabs
import GeneralTab from "./Tabs/General";


  const tabContent = [
    {panel: "general", content: <GeneralTab />},
  ]

const PayrollSettings = () => {

  const tabs = [
    {label: "General", icon: <ReceiptLongRoundedIcon fontSize="small" />},
  ];

  return (
    <SettingsLayout title="Payroll Setup" identifier="invoice_id" tabs={tabs} tabContent={tabContent} url="settings/payroll">

    </SettingsLayout>
  )
};

export default PayrollSettings;